import AddIcon from "@mui/icons-material/Add";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import {
  Box,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from "../../../assets/icons/search-icon.png";
import GlobalButton from "../../../components/button";
import { setProposalSearchValueForAgent } from "../../../lib/redux/slices/searchKeysSlice";
import { setCurrentPage } from "../../../lib/redux/slices/leadPaginationSlice";

const textFieldStyles = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "50px",
    backgroundColor: "#ffffff",
    fontSize: "0.875rem",
    "& .MuiOutlinedInput-input": {
      padding: "8px 8px !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: `1px solid`,
      borderColor: "primary.main",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: `1px solid`,
      borderColor: "primary.main",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: `1px solid`,
      borderColor: "primary.main",
    },
  },
};

const SearchTab = ({ handleOpenDialog }) => {
  const dispatch = useDispatch();
  const searchKeys = useSelector((state) => state.searchKeysReducer.searchKeys);

  const handleSearchChange = (value) => {
    dispatch(setProposalSearchValueForAgent(value));
    dispatch(setCurrentPage(1));
  };

  return (
    <Stack
      // mt={1}
      mb={2}
      px={1}
      py={2}
      gap={2}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      bgcolor="primary.light"
      flexWrap="wrap"
    >
      <Stack
        direction="row"
        alignItems="center"
        gap={2}
        flex={1}
        flexWrap={"wrap"}
      >
        <Typography variant="body2" fontSize="0.75rem" color="secondary.dark">
          Lead Proposal
          {/* ({allContracts?.length}) */}
        </Typography>
        <Box width={{ xs: "100%", sm: 300 }}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Search email"
            sx={textFieldStyles}
            value={searchKeys.proposalSearchValue}
            onChange={(e) => handleSearchChange(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <img src={SearchIcon} width={16} alt="Search" />
                </InputAdornment>
              ),
              ...(searchKeys?.proposalSearchValue && {
                endAdornment: (
                  <InputAdornment position="end">
                    <CancelOutlinedIcon
                      fontSize="small"
                      onClick={() => handleSearchChange("")}
                      sx={{ cursor: "pointer" }}
                    />
                  </InputAdornment>
                ),
              }),
            }}
          />
        </Box>
        {/* <PackagesMenu />
        <CustomRangePicker
          stackProps={{
            boxShadow: "rgba(0, 0, 0, 0.09) 0px 3px 12px",
            borderRadius: "6px",
          }}
        /> */}
      </Stack>
      <GlobalButton
        variant="custom_gradient"
        title="Add Lead"
        startIcon={<AddIcon />}
        style={{
          width: { xs: "100%", sm: 130 },
          borderRadius: "100px",
        }}
        handleClickBtn={handleOpenDialog}
      />
    </Stack>
  );
};

export default SearchTab;
